import {
  Box, Typography, Card, CardContent, CardActionArea,
  Avatar, Chip, Stack, Dialog, DialogTitle, DialogContent,
  Divider, IconButton,
} from '@mui/material';
import { useState } from 'react';
import Iconify from '../../../../components/Iconify';

function MemberDetailDialog({ member, open, onClose }) {
  if (!member) return null;
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">Member Profile</Typography>
          <IconButton onClick={onClose} size="small"><Iconify icon="mdi:close" /></IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} alignItems="center" sx={{ py: 1 }}>
          <Avatar src={member.avatar_url} sx={{ width: 64, height: 64, fontSize: 24 }}>
            {member.name?.[0]?.toUpperCase()}
          </Avatar>
          <Box textAlign="center">
            <Typography variant="subtitle1" fontWeight={700}>{member.name}</Typography>
            <Typography variant="body2" color="text.secondary">{member.email}</Typography>
          </Box>
          <Divider flexItem />
          <Stack direction="row" spacing={4}>
            <Box textAlign="center">
              <Typography variant="caption" color="text.secondary">Company</Typography>
              <Typography variant="body2">{member.company}</Typography>
            </Box>
            <Box textAlign="center">
              <Typography variant="caption" color="text.secondary">Role</Typography>
              <Typography variant="body2" sx={{ textTransform: 'capitalize' }}>{member.role}</Typography>
            </Box>
            <Box textAlign="center">
              <Typography variant="caption" color="text.secondary">Status</Typography>
              <Chip label={member.status} color={member.status === 'active' ? 'success' : 'default'} size="small" />
            </Box>
          </Stack>
          {member.mobile && (
            <Typography variant="body2" color="text.secondary">
              <Iconify icon="mdi:phone" sx={{ mr: 0.5, verticalAlign: 'middle' }} />
              {member.mobile}
            </Typography>
          )}
          {member.is_checkedin !== undefined && (
            <Chip
              icon={<Iconify icon={member.is_checkedin ? 'mdi:map-marker' : 'mdi:map-marker-off'} />}
              label={member.is_checkedin ? 'Checked In' : 'Not Checked In'}
              color={member.is_checkedin ? 'success' : 'default'}
              variant="outlined"
              size="small"
            />
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

function MemberCard({ member }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Card variant="outlined" sx={{ minWidth: 180, maxWidth: 200, flexShrink: 0, '&:hover': { boxShadow: 3 } }}>
        <CardActionArea onClick={() => setOpen(true)}>
          <CardContent sx={{ pb: '12px !important' }}>
            <Stack spacing={1} alignItems="center">
              <Avatar src={member.avatar_url} sx={{ width: 40, height: 40 }}>
                {member.name?.[0]?.toUpperCase()}
              </Avatar>
              <Box textAlign="center">
                <Typography variant="body2" fontWeight={600} noWrap sx={{ maxWidth: 160 }}>{member.name}</Typography>
                <Typography variant="caption" color="text.secondary" noWrap sx={{ maxWidth: 160, display: 'block' }}>
                  {member.company}
                </Typography>
              </Box>
              <Chip
                label={member.status}
                color={member.status === 'active' ? 'success' : 'default'}
                size="small"
                sx={{ height: 18, fontSize: 10 }}
              />
            </Stack>
          </CardContent>
        </CardActionArea>
      </Card>
      <MemberDetailDialog member={member} open={open} onClose={() => setOpen(false)} />
    </>
  );
}

export default function MemberCards({ block }) {
  const { cards = [] } = block;
  return (
    <Box sx={{ my: 1.5 }}>
      {cards.length === 0 ? (
        <Typography variant="body2" color="text.secondary">No members found.</Typography>
      ) : (
        <Box sx={{ display: 'flex', gap: 1.5, overflowX: 'auto', pb: 1 }}>
          {cards.map((m) => <MemberCard key={m.id} member={m} />)}
        </Box>
      )}
    </Box>
  );
}
